// Single place the Analytics screen reads from. In a normal build every call
// goes straight to the real API in commonApi.js; the development fixtures are
// only consulted when they have been explicitly switched on (see
// analyticsDevFixtures.js for the guard).

import { getAnalyticsDatasets, getAnalyticsSeries, getAnalyticsSummary } from '../commonApi';
import {
  areAnalyticsFixturesEnabled,
  buildFixtureSeries,
  FIXTURE_DATASETS,
  FIXTURE_SUMMARY,
} from './analyticsDevFixtures';

// The house ApiResponse envelope puts the payload under response.data.data.
const unwrap = (response) => response?.data?.data ?? response?.data ?? null;

export const fetchAnalyticsDatasets = async () => {
  if (areAnalyticsFixturesEnabled()) {
    return FIXTURE_DATASETS;
  }
  const payload = unwrap(await getAnalyticsDatasets());
  return Array.isArray(payload) ? payload : [];
};

export const fetchAnalyticsSeries = async (datasetName, { fromDate, toDate, dimension } = {}) => {
  if (areAnalyticsFixturesEnabled()) {
    return buildFixtureSeries(datasetName, fromDate, toDate);
  }
  return unwrap(await getAnalyticsSeries(datasetName, { fromDate, toDate, dimension }));
};

export const fetchAnalyticsSummary = async (asOfDate) => {
  if (areAnalyticsFixturesEnabled()) {
    return FIXTURE_SUMMARY;
  }
  return unwrap(await getAnalyticsSummary(asOfDate));
};
